import { VNode } from 'vue';
import { Wormhole } from 'portal-vue';
import { remove } from 'lodash-es';
import Backdrop from './Backdrop.vue';

interface BackdropMountOptions {
  // 展示的内容
  content: VNode;
  // 元素放置的portal节点名称
  target: string;
  // 当前展示元素的唯一id
  source: string;
  // 为指定元素添加模糊效果
  applyFilterFor?: string;
}

interface BackdropUnmountOptions {
  // 元素放置的portal节点名称
  target: string;
  // 当前展示元素的唯一id
  source: string;
}

export function mount(options: BackdropMountOptions, h: any) {
  const content = (
    // @ts-ignore
    <Backdrop key={Date.now()} visible={true} applyFilterFor={options.applyFilterFor} onHide={() => onHide()}>
      {options.content}
    </Backdrop>
  );

  const onHide = () => {
    const currentContent = Wormhole.getContentFor(options.target);
    remove(currentContent, content);
    setTimeout(() => {
      Wormhole.open({
        from: options.source,
        to: options.target,
        passengers: currentContent,
      });
    });
  };

  const prevContent = Wormhole.getContentFor(options.target);

  Wormhole.open({
    from: options.source,
    to: options.target,
    passengers: prevContent.concat(content),
  });

  return () => {
    setTimeout(() => {
      const instance = content.componentInstance as any;
      instance.onVisibilityChange(false);
    });
  };
}

function unmount(options: BackdropUnmountOptions) {
  Wormhole.close({
    from: options.source,
    to: options.target,
  }, true);
}

export default class BackdropExtended extends Backdrop {
  static mount = mount;
}
